// @flow
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import useAuth from '@user/hooks/useAuth';
import RolesHelpers from '@user/helpers/RolesHelpers';
import { WEB_PATHS } from '@app/constants/paths';

const { PAGE_NOT_FOUND } = WEB_PATHS;

const AdminRoute = (): React$Node => {
  const { user, isConnected, isLoading } = useAuth();

  if (isLoading) {
    return null;
  }

  const isAdmin = isConnected && RolesHelpers.hasRoleAdmin(user?.role);

  return isAdmin ? <Outlet /> : <Navigate to={ PAGE_NOT_FOUND } />;
};

export default AdminRoute;
